<div class="choices-multiple-answer">
  <div class="choices-multiple-answer__list">
    <app-checkbox *ngFor="let choice of question.answer_choices" class="choices-multiple-answer__list-item">
      <input type="checkbox" />
      <checkbox-text>{{ choice.text }}</checkbox-text>
    </app-checkbox>
  </div>
  <span *ngIf="withComment" class="choices-multiple-answer__comment">+ комментарий</span>
</div>
